import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import menuFamilyNeedALoan from './menuFamilyNeedALoan/menuFamilyNeedALoan';
import menuOptionsFamily from './menuFamilyNeedALoan/menuOptionsFamily/menuOptionsFamily';
import requestCardSimulationFamily from './requestCardSimulationFamily/requestCardSimulationFamily';
import needALoanFamilySelect from './needALoanFamilySelect/needALoanFamilySelect';
import needALoanModal from './needALoanModal/needALoanModal';

import needALoanComponent from './needALoan.component';

let needALoanModule = angular.module('needALoan', [
  uiRouter,
  menuFamilyNeedALoan,
  menuOptionsFamily,
  requestCardSimulationFamily,
  needALoanFamilySelect,
  needALoanModal,
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state(STATES.LOANS.NEED_A_LOAN, {
      url: ROUTES.LOANS.NEED_A_LOAN,
      component: 'needALoan',
      params: {
        snapshot: null,
      },
      data: {
        requiresAuth: true,
      },
      resolve: {
        /* @ngInject */
        serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed()
      }
    });
})

.component('needALoan', needALoanComponent)

.name;

export default needALoanModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoan.js